var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95418 31.0457 -0.00012207 20 -0.00012207C8.95434 -0.00012207 3.05176e-05 8.95418 3.05176e-05 19.9999C3.05176e-05 31.0456 8.95434 39.9999 20 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85787 34.1421C6.69686 34.9811 7.59201 35.7293 8.531 36.388L36.388 8.53092C35.7294 7.59194 34.9812 6.69678 34.1422 5.8578C33.3031 5.01881 32.408 4.27069 31.469 3.61194L3.61209 31.469C4.27068 32.4078 5.01897 33.303 5.85787 34.1421V34.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.8578C-0.451683 12.1675 -1.66301 21.6433 2.2216 29.1701L29.1702 2.22163C21.6434 -1.66298 12.1675 -0.451576 5.85785 5.8578V5.8578Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1421 34.1421C40.4516 27.8325 41.6629 18.3565 37.7784 10.8297L10.8298 37.7783C18.3565 41.6629 27.8325 40.4516 34.1421 34.1421Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanzania);
export default __webpack_public_path__ + "static/media/tanzania.f76db75fd7e863bd5980cabee490393b.svg";
export { ForwardRef as ReactComponent };